<template>
  <b-modal
      :id="id"
      centered
      footer-class="border-0 pt-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      @hidden="handleHidden"
  >
     <div class="text-center py-2">
       <div class="success-icon mx-auto mb-3">
         <i class="bx bx-check"></i>
       </div>
       <h4 class="mb-2">{{ successTitle }}</h4>
       <p class="mb-0" v-if="successMessage">{{ successMessage }}</p>
     </div>
     <template #modal-footer>
       <div class="d-flex justify-content-end w-100">
         <b-button
             block
             class="close-action-btn"
             variant="light"
             @click="handleClose"
         >
           {{ $t('Close') }}
         </b-button>
       </div>
     </template>
  </b-modal>
</template>

<script>
export default {
  name: 'balancing-approval-bulk-action-success',
  props: {
    id: {
      default: 'balancing-approval-bulk-action-success-modal',
    },
  },
  data() {
    return {
      options: {
        title: null,
        message: null,
      },
      resolvePromise: null,
    };
  },
  computed: {
    successTitle() {
      return this.options.title || `${this.$t('Success')}!`;
    },
    successMessage() {
      return this.options.message || '';
    },
  },
  methods: {
    show(options = {}) {
      return new Promise((resolve) => {
        this.options = {
          title: null,
          message: null,
          ...options,
        };
        this.resolvePromise = resolve;
        this.$bvModal.show(this.id);
      });
    },
    handleClose() {
      if (this.resolvePromise) {
        this.resolvePromise(true);
        this.resolvePromise = null;
      }
      this.$bvModal.hide(this.id);
    },
    handleHidden() {
      this.$emit('hidden');
      if (this.resolvePromise) {
        this.resolvePromise(true);
        this.resolvePromise = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.success-icon {
  align-items: center;
  background: rgba(25, 135, 84, 0.12);
  border-radius: 999px;
  color: #198754;
  display: inline-flex;
  height: 72px;
  justify-content: center;
  width: 72px;

  i {
    font-size: 40px;
  }
}

.close-action-btn {
  font-weight: bold;
}
</style>
